import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import ProductStockList, { ProductStockItem } from '../Components/ProductStockList';
import {
  useGetHKMProductsQuery,
  useGetHKMProductStockQuery,
  useUpdateHKMProductImageMutation,
} from '../redux/services/hkmproductApi';

const HKProducts = ({ navigation }: any) => {
  const cid = useSelector((state: RootState) => state.gdata.company);
  const { data: products = [], isLoading, refetch } = useGetHKMProductsQuery(cid, { skip: !cid });
  const { data: stock = [], refetch: refetchStock } = useGetHKMProductStockQuery(undefined, { skip: !cid });
  const [updateImage] = useUpdateHKMProductImageMutation();

  const items = useMemo<ProductStockItem[]>(() => {
    const stockMap = new Map<number, number>();
    stock.forEach(s => stockMap.set(Number(s.pr_id), Number(s.pr_stock)));
    return (Array.isArray(products) ? products : [])
      .filter((p: any) => p.pr_flag !== '0')
      .map((p: any) => ({
        id: Number(p.pr_id),
        name: p.pr_name,
        code: p.pr_code || '',
        uom: String(p.pr_uom || ''),
        stock: stockMap.get(Number(p.pr_id)) ?? 0,
        image: p.pr_image || '',
      }))
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [products, stock]);

  return (
    <ProductStockList
      title="HK Products"
      items={items}
      isLoading={isLoading}
      onRefresh={() => Promise.all([refetch(), refetchStock()])}
      saveImage={(id, key) => updateImage({ pr_id: id, pr_image: key }).unwrap()}
      onBack={() => navigation?.goBack?.()}
    />
  );
};

export default HKProducts;
